module.exports = "https://web-assets.ifttt.com/packs/media/home/get-started-tree-1x-1d2569f5.png";